<template>
    <div class="form-row form-submit-row" :class="{'flex flex-wrap button-container flex-align-right': isFlex}" v-sticky="floatingEnabled" @click="submitClicked">
        <slot v-bind="{submitClicked, deleteCallback, disableSave}">
            <template v-if="showActionSave">
                <form-input-save v-if="showActionSaveOptions"
                    :class="{'flex--order-10': isFlex}" type="submit"
                    name="action_save" class="submit-form" :disabled="disableSave"/>
                <form-input-submit v-else :class="{'flex--order-10': isFlex}"
                    name="action_save" class="submit-form button button-save" :disabled="disableSave">
                    <i class="material-icons" aria-hidden="true" role="img">save</i> <span>Speichern</span>
                </form-input-submit>
            </template>

            <form-input-submit v-if="showActionApply && viewSize.lgUp" name="action_apply" class="button button-apply" :disabled="disableSave"
                :class="{'flex--order-9': isFlex}">
                <i class="material-icons" aria-hidden="true" v-text="SubmitIcons.save" role="img"></i> <span>Zwischenspeichern</span>
            </form-input-submit>

            <div class="button-separator" :class="{'flex--order-6': isFlex}"/>

            <a v-if="deleteCallback" :class="{'flex--order-5': isFlex}" class="button button-danger" @click="deleteCallback">
                <i class="material-icons" aria-hidden="true" v-text="SubmitIcons.delete" role="img"></i> <span>Löschen</span>
            </a>

            <slot name="custom-button"/>

            <form-input-submit v-if="showActionCancel" name="action_cancel" formnovalidate="formnovalidate" class="button button-cancel spacer-right-15" :class="{'flex--order-1': isFlex}">
                <i class="material-icons" aria-hidden="true" v-text="SubmitIcons.close" role="img"></i> <span>Abbrechen</span>
            </form-input-submit>

            <form-input-submit v-if="showActionReset" name="action_reset" formnovalidate="formnovalidate" class="button button-cancel spacer-right-15" :class="{'flex--order-1': isFlex}">
                <span>{{actionResetText}}</span>
            </form-input-submit>
        </slot>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import {SubmitIcons} from '../../library/design';
    import FormInput from './FormInput.vue';
    import FormInputSave from './FormInputSave.vue';
    import FormInputSubmit from './FormInputSubmit.vue';

    @Component({
        name: 'FormSubmitRow',
        components: {
            FormInputSubmit,
            FormInput,
            FormInputSave,
        },
        emits: ['cancel', 'submit', 'reset'],
    })
    export default class FormSubmitRow extends Vue
    {
        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) floating: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) noFlex: boolean;

        @Prop({
            type: [String, Object],
            default()
            {
                return {};
            },
        }) redirectOnCancel: string | object;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) followRef: boolean;

        @Prop({
            type: [Function, Boolean],
            default: false,
            required: false,
        }) deleteCallback: VoidFunction;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) disableSave: boolean;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) showActionSave: boolean;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) showActionSaveOptions: boolean;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) showActionApply: boolean;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) showActionCancel: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) showActionReset: boolean;

        @Prop({
            type: String,
            default: 'Zurücksetzen',
            required: false,
        }) actionResetText: string;

        SubmitIcons = SubmitIcons;

        get isFlex()
        {
            return !this.noFlex;
        }

        get floatingEnabled()
        {
            return this.floating && this.viewSize.smUp;
        }

        submitClicked(event: Event)
        {
            let target: HTMLElement | HTMLInputElement | HTMLButtonElement = event.target as HTMLElement;

            // clicked an icon or something
            if (target.parentElement && ['input', 'button'].includes(target.parentElement.nodeName.toLowerCase()))
            {
                target = target.parentElement;
            }

            event.stopPropagation();
            event.preventDefault();

            if ((target instanceof HTMLButtonElement || target instanceof HTMLInputElement) && 'submit' === target.type)
            {
                let action = '';

                if (target.name === 'action_cancel')
                {
                    action = 'cancel';
                }
                else if (target.name === 'action_reset')
                {
                    action = 'reset';
                }
                else
                {
                    action = 'submit';
                }

                this.$emit(action, target);

                if (action === 'cancel')
                {
                    this.routerGoBack(this.redirectOnCancel, this.followRef);
                }
            }
        }
    }
</script>